import { Grid, List, ListItem, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";
import { useTranslation } from "react-i18next";
import { useFieldArray, useFormContext } from "react-hook-form";
import { UserDetails } from "./User";
import { TermsAndConditionsAcceptance } from "./TermsAndConditionsAcceptance";
import { useApplicationFormatter } from "../applications/ApplicationProvider";

export function AcceptedTermsAndConditionsForm(props: {
  disabled?: boolean
}) {
  const { t } = useTranslation();
  const theme = useTheme();
  const { control } = useFormContext<UserDetails>();
  const { fields, remove } = useFieldArray<UserDetails>({
    control,
    name: "acceptedTermsAndConditions"
  });

  return (
    <Grid container={true}>
      <Grid item={true} lg={12} sx={{
        display: 'flex',
        alignItems: 'center',
        '& > *': {
          marginRight: theme.spacing(2)
        }
      }}>
        <Typography variant={'h4'}>{t('TermsAndConditions.title') + ':'}</Typography>
      </Grid>
      <List>
        {fields.map((acceptance: any, index: number) =>
          <AcceptedTermsAndConditions acceptance={acceptance} index={index} remove={remove} disabled={props.disabled} key={index} />
        )}
      </List>
    </Grid>
  )
}

export function AcceptedTermsAndConditions(props: {
  acceptance: TermsAndConditionsAcceptance,
  index: number,
  remove: (index?: number | number[]) => void,
  disabled?: boolean
}) {
  const applicationFormatter = useApplicationFormatter();

  const { t } = useTranslation();

  return (
    <ListItem>
      <Typography
        variant={'body1'}>{applicationFormatter.formatApplication(props.acceptance.application.name) + ': ' + t('TermsAndConditions.accepted')}</Typography>
    </ListItem>
  );
}
